import React from 'react';
import { Box, Button, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/react';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common';
import { useOnboardingPageBi } from '../../hooks/useOnboardingPageBi';

export function GetIdeaSection() {
  const { t } = useTranslation();
  const { reportBiClick } = useOnboardingPageBi();
  return (
    <Box
      direction="vertical"
      width="100%"
      align="center"
      gap="SP2"
      paddingTop="SP8"
      paddingBottom="SP8"
    >
      <Text size="medium">
        <span style={{ fontSize: '22px' }}>
          {t('devibe.onboarding.get_idea.title')}
        </span>
      </Text>
      <Button
        as="a"
        target="_blank"
        href="https://dev.wix.com/docs/build-apps/get-started/get-an-idea"
        skin="dark"
        size="medium"
        suffixIcon={<ExternalLinkSmall />}
        onClick={() => {
          reportBiClick({
            buttonName: 'Get high-demand app ideas',
          });
        }}
      >
        {t('devibe.onboarding.get_idea.button')}
      </Button>
    </Box>
  );
}
